module.exports = __webpack_public_path__ + "img/footer-5.8c043996.gif";